import { render, staticRenderFns } from "./oldLogistics.vue?vue&type=template&id=bfc69d34&scoped=true"
import script from "./oldLogistics.vue?vue&type=script&lang=js"
export * from "./oldLogistics.vue?vue&type=script&lang=js"
import style0 from "./oldLogistics.vue?vue&type=style&index=0&id=bfc69d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc69d34",
  null
  
)

export default component.exports